module.exports = __webpack_public_path__ + "static/media/linkedin.9fec94fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/linkedin.png
// module id = 148
// module chunks = 0